import { render, staticRenderFns } from "./BulkDeleteDetail.vue?vue&type=template&id=95e2bdfc&scoped=true"
import script from "./BulkDeleteDetail.vue?vue&type=script&lang=js"
export * from "./BulkDeleteDetail.vue?vue&type=script&lang=js"
import style0 from "./BulkDeleteDetail.vue?vue&type=style&index=0&id=95e2bdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e2bdfc",
  null
  
)

export default component.exports